<style src='@/resources/styles/about.css' scoped></style>

<template>
  <main>
    <div class='inner cover'>
      <h1 class='lead'>Our Story</h1>
      <p class='blurb'>
        Domain Squatters are using technology to buy up almost every good name, so they can force you to pay thousands
        of dollars to get the name of your choice.
      </p>

      <br /><br />
      <p class='blurb'>
        After experiencing this firsthand, the idea for Naminus was born. It started with a hunch, that an algorithm
        could be used to generate great sounding, unique names. Like Google, Expedia, and Heroku. And because these
        names are unique, they're less likely to be owned by a domain squatter.
      </p>

      <br /><br />

      <p class='blurb'>
        The very first version of Naminus produced absolutely terrible names. But every once in a while, a great name
        would show up. It took a lot of iteration, experimentation, love, and tears, to get Naminus to be as good as
        it is today.
      </p>

      <br /><br />
      <p class="blurb">
        <strong>Fun fact:</strong> The names Naminus, and Criminull (our company name), were generated by Naminus
        itself!
      </p>

      <br /><br />
      <div class='team'>

        <h1 class='lead'>Team</h1>
        <div class='member senor'>
          <div class='portrait'></div>
          <div class='name'>
            Señor
          </div>
          <div class='title'>Feline Overlord</div>
          <p>Secretly, he runs everything around here.</p>
        </div>


        <div class='member ali'>
          <div class='portrait'></div>
          <div class='name'>
            Ali Akhtar
            <a target='_blank' class='twitter' href='https://www.twitter.com/AliAkhtar_'></a>
          </div>
          <div class='title'>Founder, Developer.</div>
          <p>Backend developer with raging ADHD. Passionate about AI, Natural Language Processing, and Scala. </p>
        </div>

        <div class='member jr'>
          <div class='portrait'></div>
          <div class='name'>
            Jean “JR” Desgrottes Jr
            <a target='_blank' class='twitter' href='https://www.twitter.com/dsgrtts'></a>
          </div>
          <div class='title'><strong>Killer</strong> UI Designer</div>
          <p>Basically what Steve Jobs wanted to be like, but wasn't good enough to be. Designer + <a
                  href="https://www.youtube.com/watch?v=9aCvrlifLkM" target="_blank" style="color:white;">Musician</a>.
          </p>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
  import States from "../../States"
  import {mapActions} from "vuex";

  export default {
    name: 'AboutView',

    mounted() {
      this.pageLoaded(this.$route);
    },

    methods:  {
      ...mapActions(['pageLoaded'])
    }
  }
</script>
